/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownTaskStatus } from '../models/db_DropdownTaskStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskStatuses {
    /**
     * Get a list of task statuses
     * @returns db_DropdownTaskStatus OK
     * @throws ApiError
     */
    public static listTaskStatuses(): CancelablePromise<Array<db_DropdownTaskStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/task-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
